const RecentAlertsWidgetLayout = {
  xl: {
    h: 3,
    w: 10,
    x: 0,
    y: 1
  },
  lg: {
    h: 3,
    w: 7,
    x: 0,
    y: 1
  },
  md: {
    h: 3,
    w: 4,
    x: 0,
    y: 1
  },
  sm: {
    h: 3,
    w: 5,
    x: 5,
    y: 1
  },
  xs: {
    h: 3,
    w: 4,
    x: 5,
    y: 1
  }
};

export default RecentAlertsWidgetLayout;
